/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Junaid Muzaffar",
  logo_name: "Junaid Muzaffar",
  subTitle:
    "An accomplished AI Engineer, well versed in ML/DL, Computer Vision and Natural Language Processing. Involved in the open-source Python community, and looking forward to expand my experience in the above-mentioned fields.",
  resumeLink:
    "https://drive.google.com/file/d/1qRqiCMqvAwcuHvyAjwGbR4hv07AjhbJs/view?usp=sharing",
  portfolio_repository: "https://github.com/junaid340",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/junaid340",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/junaid-muzaffar-0fficial/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link:
      "https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=junaid.muzaffar340@gmail.com&subject=MISSED%20CALL%20EZTRADER&body=Hello",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Stackoverflow",
    link: "https://stackoverflow.com/users/6333690/junaid-khan",
    fontAwesomeIcon: "fa-stack-overflow", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#FE7A16", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/Lion.King340",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/junaid.muzafar/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various Deep Learning and Machine Learning use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Well versed in Research and Development in ML/DL and AI",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "simple-icons:tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "PyTorch Lightning",
          fontAwesomeClassname: "simple-icons:pytorchlightning",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "ONNX",
          fontAwesomeClassname: "simple-icons:onnx",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Scikit-Learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Scipy",
          fontAwesomeClassname: "simple-icons:scipy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Cmake",
          fontAwesomeClassname: "simple-icons:cmake",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Dlib",
          fontAwesomeClassname: "simple-icons:dlib",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "SpaCy",
          fontAwesomeClassname: "simple-icons:spacy",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Deploying ML/DL models on cloud to use on mobile devices",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and AWS",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            backgroundColor: "transparent"
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front/back ends",
        "⚡ Implementing dynamic script execution defined by user",
        "⚡ Implementing secure access to database",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
         style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Nginx",
          fontAwesomeClassname: "simple-icons:nginx",
        },
      ],
    },
  ],
};

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "ML/DL",
      progressPercentage: "70%",
    },
    {
      Stack: "Cloud & DevOps",
      progressPercentage: "60%",
    },
    {
      Stack: "Full Stack", //Insert stack or technology you have experience in
      progressPercentage: "50%", //Insert relative proficiency in percentage
    }
  ],
};

//Language Skill
const sLanguage = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Tensorflow",
      progressPercentage: "70%",
    },
    {
      Stack: "TensorRT",
      progressPercentage: "60%",
    },
    {
      Stack: "Pytorch",
      progressPercentage: "70%",
    },
    {
      Stack: "Pytorch Lightning",
      progressPercentage: "60%",
    },
    {
      Stack: "ONNX",
      progressPercentage: "60%",
    },
    {
      Stack: "OpenCv",
      progressPercentage: "85%",
    },

    {
      Stack: "Scikit-Learn",
      progressPercentage: "78%",
    },

    {
      Stack: "SciPy",
      progressPercentage: "75%",
    },

    {
      Stack: "Dlib",
      progressPercentage: "65%",
    },

    {
      Stack: "SpaCy",
      progressPercentage: "70%",
    },
    {
      Stack: "Python", //Insert stack or technology you have experience in
      progressPercentage: "70%", //Insert relative proficiency in percentage
    },
    {
      Stack: "C/C++",
      progressPercentage: "70%",
    },
    {
      Stack: "HTML", //Insert stack or technology you have experience in
      progressPercentage: "60%", //Insert relative proficiency in percentage
    },
    {
      Stack: "CSS",
      progressPercentage: "60%",
    },
  ],
};

//Tools Skill
const tools = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Visual Studio", //Insert stack or technology you have experience in
      progressPercentage: "80%", //Insert relative proficiency in percentage
    },
    {
      Stack: "PyCharm", //Insert stack or technology you have experience in
      progressPercentage: "85%", //Insert relative proficiency in percentage
    },
    {
      Stack: "Google Colab",
      progressPercentage: "95%",
    },
    {
      Stack: "Netbeans",
      progressPercentage: "80%",
    },
    {
      Stack: "Microsoft Office",
      progressPercentage: "90%",
    },
    {
      Stack: "Google Docs",
      progressPercentage: "90%",
    },
    {
      Stack: "Github",
      progressPercentage: "80%",
    },
    {
      Stack: "Unreal Engine",
      progressPercentage: "50%",
    },
    {
      Stack: "Carla",
      progressPercentage: "40%",
    },
    {
      Stack: "Reality Capture",
      progressPercentage: "65%",
    },
    {
      Stack: "Agisoft",
      progressPercentage: "70%",
    },
    {
      Stack: "Meshroom",
      progressPercentage: "68%",
    },
  ],
};

// Education Page
const degrees = {
  degrees: [
    {
      title: "COMSATS University Islamabad",
      subtitle: "B.Sc. in Electronics",
      logo_path: "CUI2.png",
      alt_name: "CUI",
      duration: "September 2015 - August 2019",
      cgpa: "3.56 / 4.00",
      descriptions: [
        "⚡ Major courses include ICP, OOP, DLD, DSP, Singal Systems, EMT, Microprocessor Systems and Interfacing, RealTime Embedded Systems and Control Systems",
        "⚡ Did my Final Year Project in the field of Natural Language Processing and Machine Learning",
        "⚡ Shortlisted for NGIRI-Ignite all Pakistan FYP Competition",
        "⚡ Campus Gold Medalist",
        "⚡ Represented my batch complete degree tenure",
      ],
      website_link: "https://www.comsats.edu.pk/",
    },
    {
      title: "National University of Computer and Emerging Sciences Islamabad",
      subtitle: "M.Sc. in Data Science",
      logo_path: "FAST.png",
      alt_name: "FAST",
      duration: "September 2020 - Januray 2023",
      cgpa: "3.1 / 4.00",
      descriptions: [
        "⚡ Major courses include Stats&Maths for Machine Learning, Tools & Techniques for M/L, Machine Learning, NLP, Advance AI, Big Data Analysis and Social Network Analysis",
        "⚡ Research Topic: Point Cloud Upsampling using Diffusion Models",
        "⚡ Standout Course project: Image2Image translation using Cycle-Consistent GAN",
      ],
      website_link: "https://www.nu.edu.pk/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Python Basics",
      subtitle: "- Charles Russell Severance",
      logo_path: "michigan_logo.png",
      //certificate_link:
      //  "https://coursera.org/share/39d3749b06308a77e0f596129029d4fe",
      alt_name: "Michigan University",
      color_code: "#2A73CC",
    },
    
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      //certificate_link:
      //  "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      //certificate_link:
      //  "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      //certificate_link:
      //  "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  //subtitle: "Work, Internship and Volunteership",
  description:
    "I'm an accomplished AI/ML Engineer, having more than 2 years of experience in AI, ML/DL, Computer Vision,Data Science and DevOps. Looking forward to expand my experience in respective fields!",
  header_image_path: "experience.svg",
  experiences: [
    {
      title: "Senior AI Engineer",
      subtitle: "Synapsify",
      logo_path: "synap1.png",
      alt_name: "syn",
      duration: "May 2022 - PRESENT",
      location: "Islamabad",
      descriptions: [
        "⚡ Team Lead for Synthetic Data & ML teams",
        "⚡ Responsible for Research & Development",
        "⚡ Supervise Development and Deployment of AI/ML models",
        "⚡ Supervise day-to-day operations",
        "⚡ Propose deadlines for projects and makesure to meet them",
      ],
      website_link: "https://www.synapsify.tech/",
    },
    {
      title: "Machine Learning Engg. Consultant",
      subtitle: "Cerebriam Studios",
      logo_path: "cbf.png",
      alt_name: "cbs",
      duration: "Sep 2021 - Nov 2021",
      location: "London, UK",
      descriptions: [
        "⚡ Provided consultancy for ML model testing and integration",
        "⚡ Evaluated given ML models for accuracy and performance",
        "⚡ Helped front-end developers with ML model integration with React App",
      ],
      website_link: "https://cerebriam.com/",
    },
    {
      title: "Python Developer",
      subtitle: "Zigron Inc.",
      logo_path: "zig1.png",
      alt_name: "Zigron",
      duration: "Oct 2020 - Jul 2021",
      location: "Islamabad",
      descriptions: [
        "⚡ Worked as Junior Python Developer with Firmware team on TerraSmart project",
        "⚡ Responsible to monitor Network Controllers",
        "⚡ Set-up new Network Controllers and monitor their Firmware",
        "⚡ Troubleshooting and bug fixing for faulty NC-Firmwares",
      ],
      website_link: "https://zigron.com/",
    },
    {
      title: "Machine Learning Engineer",
      subtitle: "Upwork",
      logo_path: "up1.png",
      alt_name: "u[",
      duration: "June 2018 - Oct 2020",
      location: "Islamabad",
      descriptions: [
        "⚡ Provided services as Machine Learning Engineer",
        "⚡ Poduced many research based solutions to many clients",
        "⚡ Helped many clients with implementations of state-of-art research papers",
      ],
      //website_link: "https://www.nu.edu.pk/",
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to develop AI/ML projects and deploy them to web applications using cloud infrastructure. Stil trying to gain experience by trying my hands on different domains. Most of these are freelance projects with some personal projects in between, because of NDA's I can't share projects affiliated with Companies and some clients.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "junaid_pic.png",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with Basic Programming, ML, AI, Cloud and Opensource Development.",
  },
  /*blogSection: {
    title: "Blogs",
    subtitle:
      "I like to write about the projects I've worked on, my current work and discuss my latest foundings. You are most welcome to input your thoughts on my projects.",
    link: "https://miftaulmannan.wordpress.com/projects/",
    avatar_image_path: "blogs_image.svg",
  },*/
  addressSection: {
    title: "Address",
    subtitle: "Jahaz Ground-Khanna Pul, Rawalpindi, Pakistan",
    avatar_image_path: "address_image.svg",
    //location_map_link: "https://goo.gl/maps/yV1Vkp7L3to9qvKX6",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+92 3355254615",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  sLanguage,
  tools,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
